// extracted by mini-css-extract-plugin
export default {"homeButton":"PuzzleHut_homeButton__BGY8f","graphContainer":"PuzzleHut_graphContainer__S5RRg"};